import dayjs from "dayjs";
import type { CustomerOrder } from "../../api/customer/customerOrdersApi";

// CU-86d45b2zn: order_date is a calendar date (YYYY-MM-DD) with no instant, so it is read as-is, never shifted through UTC.
export const formatOrderDate = (orderDate: string | null | undefined): string => {
	if (!orderDate) return "—";

	const parsed = dayjs(orderDate);
	return parsed.isValid() ? parsed.format("DD MMM YYYY") : "—";
};

// CU-86d45b2zn: Shopify reports "not yet fulfilled" as null; a clinic sale has no fulfilment state at all.
export const fulfilmentStatus = (order: CustomerOrder): string | null =>
	order.fulfillment_status ?? (order.is_shopify_order ? "unfulfilled" : null);
